import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const dashusersEndpoints = config.endpoints.dashusers
const operatorsEndpoints = config.endpoints.operators

/**
 * Add a new channel to the user
 * @param {Object} channel
 */
const addChannel = (channel) =>
  axios({
    method: 'post',
    url: dashusersEndpoints.channels,
    headers: getHeaders(true),
    data: { channelId: channel.id, channel: channel.name },
  })

const getChannels = () =>
  axios({
    method: 'get',
    url: `${dashusersEndpoints.channels}`,
    headers: getHeaders(true),
  })

const updateChannel = (channel) =>
  axios({
    method: 'put',
    url: `${dashusersEndpoints.channels}/${channel.id}`,
    headers: getHeaders(true),
    data: { channel },
  })

const getList = () =>
  axios({
    method: 'post',
    url: operatorsEndpoints.channelsList,
    headers: getHeaders(true)
  })

const autoAssignmentPriority = (operatorId) => {
  return axios({
    method: 'post',
    url: operatorsEndpoints.autoAssignmentPriority,
    headers: getHeaders(true),
    data: { operatorId }
  })
}

export default {
  addChannel,
  getChannels,
  updateChannel,
  getList,
  autoAssignmentPriority
}
